import { List, Tag, Descriptions } from "antd";
import React, { useEffect, useState } from "react";
import { PilotLink } from "~/components/flight/sections/PilotLink.jsx";
import { HelpLine } from "~/components/help/helpLine.jsx";
import { Loading } from "~/components/loader/Loading.jsx";
import { $t } from "~/i18n.js";
import { api } from "~/lib/api.js";
import { _parseDateTime } from "~/lib/localize.js";

const SENT = "sent";
const OPENED = "opened";
const FAILED = "failed";

export const EmailStats = ({ campaign }) => {
  const [mails, setMails] = useState(null);
  const [filter, setFilter] = useState(SENT);

  useEffect(() => {
    let cancelled = false;

    api.get(`campaign/${campaign.id}/mails.json`).then((res) => {
      if (!cancelled) setMails(res?.mails || []);
    });

    return () => {
      cancelled = true;
    };
  }, [campaign.id]);

  if (!mails) return <Loading />;

  const failed = campaign.failed_recipients || [];

  // campaigns sent before per-recipient tracking have no mails
  const hasMails = mails.length > 0;
  const opened = mails.filter((m) => m.date_first_opened);
  const sentOnly = mails.filter((m) => !m.date_first_opened);

  const lists = { [SENT]: sentOnly, [OPENED]: opened, [FAILED]: failed };

  return (
    <section>
      <Descriptions
        size="small"
        column={1}
        style={{ marginBottom: 12 }}
      >
        <Descriptions.Item label={$t("Verstuurd")}>
          {hasMails ? mails.length : campaign.n_send}
        </Descriptions.Item>
        <Descriptions.Item label={$t("Geopend")}>
          {hasMails ? opened.length : "-"}
        </Descriptions.Item>
        <Descriptions.Item label={$t("Mislukt")}>
          {failed.length}
        </Descriptions.Item>
      </Descriptions>

      <div style={{ marginBottom: 8 }}>
        <Tag.CheckableTag
          checked={filter === SENT}
          onChange={() => setFilter(SENT)}
        >
          {sentOnly.length} {$t("Verstuurd")}
        </Tag.CheckableTag>
        <Tag.CheckableTag
          checked={filter === OPENED}
          onChange={() => setFilter(OPENED)}
        >
          {opened.length} {$t("Geopend")}
        </Tag.CheckableTag>
        <Tag.CheckableTag
          checked={filter === FAILED}
          onChange={() => setFilter(FAILED)}
        >
          {failed.length} {$t("Mislukt")}
        </Tag.CheckableTag>
      </div>

      <List
        style={{ maxHeight: 400, overflowY: "auto" }}
        itemLayout="horizontal"
        size="small"
        bordered={false}
        dataSource={lists[filter]}
        renderItem={(item) => {
          // mails link to the profile via user_id, failed recipients via id
          const userId = item.user_id || item.id;
          const isFailed = filter === FAILED;
          const isOpened = !isFailed && !!item.date_first_opened;
          return (
            <List.Item
              actions={[
                isFailed ? (
                  <Tag key="status" color="error">
                    {$t(item.reason || "failed")}
                    {/* $t('invalid') $t('unsubscribed') $t('failed') */}
                  </Tag>
                ) : (
                  <Tag key="status" color={isOpened ? "success" : "processing"}>
                    {isOpened ? $t("Geopend") : $t("Verstuurd")}
                  </Tag>
                ),
              ]}
            >
              <List.Item.Meta
                description={
                    <div className='row' style={{gap: 12}}>
                      {userId && (
                        <PilotLink
                          name={item.name}
                          id={userId}
                          object={{ id: userId }}
                          showID={false}
                        />
                      )}
                      <span>
                        {item.email}
                      </span>

                      {item.date_first_opened && (<span>

                        | {_parseDateTime(item.date_first_opened)}
                    
                      </span>)
                      }
                    </div>                    
                }
              />
            </List.Item>
          );
        }}
      />

      <HelpLine style={{marginTop: 24}}>
        {$t("Note: Datum eerst geopend is niet accuraat, sommige email providers openen de mail op de achtergrond, andere blokkeren het. Desondanks geeft het een indicatie.")}
      </HelpLine>
    </section>
  );
};
